<template>
  <div id="app">
    <template v-if="isAuth">
      <div v-if="loading" class="loading-container">
        Loading...
      </div>
      <template v-else>
        <router-view></router-view>
      </template>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
    <div class="version">1.2.9</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      loading: false /* change when we load stuff...*/
    };
  },
  mounted() {
    console.log('mounted');

    if (this.isAuth) {
      this.$store.commit('setAuthToken', localStorage.getItem('authToken'));
    }
  }
};
</script>

<style lang="scss">
@import '@/sass/style.scss';

.version {
  position: fixed;
  bottom: 5px;
  right: 10px;
  font-size: 10px;
  color: #333;
}
</style>
